import React from 'react';
import { useTranslation } from 'react-i18next';

import Switch from 'components/Controls/Switch';
import { useGridExpand } from 'components/Grids/DataGrid/hooks/useGridExpand';
import { appReactMemo } from 'hocs';

interface IExpandTableSwitchProps {
  className?: string;
  pageKey?: string;
}

const ExpandTableSwitch = ({ className, pageKey }: IExpandTableSwitchProps) => {
  const { t } = useTranslation('translation', { keyPrefix: 'common.gridSettings' });

  const { isExpanded, onToggleExpand } = useGridExpand(pageKey);

  if (!pageKey) {
    return null;
  }

  return (
    <Switch
      checked={isExpanded}
      className={className}
      label={t('expandTable')}
      onChange={onToggleExpand}
      testIds={{ container: 'gridExpandTableSwitch' }}
    />
  );
};

export default appReactMemo(ExpandTableSwitch);
